<script>
import { createInternalConsumption, updateInternalConsumption } from '@/utils/internal-consumption'

export default {

    inject: ['setLoading'],

    data() {
        return {
            id: null,
            name: '',
            code: '',
            description: '',
            errors: {}
        }
    },

    methods: {

        open(row = null) {
            this.reset()

            if (row) {
                this.id = row.id
                this.name = row.name
                this.code = row.code
                this.description = row.description || ''
            }
        },

        async save() {
            this.setLoading(true)

            try {
                const payload = {
                    name: this.name,
                    code: this.code,
                    description: this.description,
                }

                let res

                if (this.id) {
                    res = await updateInternalConsumption(this.id, payload)
                } else {
                    res = await createInternalConsumption(payload)
                }

                this.$swalToast(res.data.message)
                this.$emit('updated')
                this.$closeModal('internal_consumption_modal')

            } catch (error) {
                if (error.type === 'validation') {
                    this.errors = error.errors
                } else {
                    this.$swalToast(error.message, 'error')
                }
            } finally {
                this.setLoading(false)
            }
        },

        reset() {
            this.id = null
            this.name = ''
            this.code = ''
            this.description = ''
            this.errors = {}
        }
    }
}
</script>

<template>
    <div class="modal fade" id="internal_consumption_modal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-header">
                    <h5>{{ id ? 'Edit' : 'Add' }} Internal Consumption</h5>
                    <button class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <form @submit.prevent="save">
                    <div class="modal-body">

                        <div class="mb-3">
                            <label class="form-label">Name <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="name" placeholder="Enter name" />
                            <div v-if="errors.name"
                                style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                                <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.name[0] }}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Code <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="code" placeholder="Enter code" />
                            <div v-if="errors.code"
                                style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                                <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.code[0] }}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Description</label>
                            <textarea class="form-control" v-model="description" rows="3" placeholder="Enter description"></textarea>
                            <div v-if="errors.description"
                                style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                                <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.description[0] }}
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary">Save</button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>